export default "__VITE_ASSET__CeRsuQxh__"